import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/index'
import {storageMiddleware} from './tabSyncMiddleware'
import { createTracker } from 'redux-segment'
const tracker = createTracker()

const store = createStore(
	rootReducer,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), 
	applyMiddleware(thunk,storageMiddleware(),tracker)			
)

export default store




// WEBPACK FOOTER //
// ./src/store.js